function t(e, r) {
  return r ? Object.keys(r).reduce(
    (n, c) => n.replace(`{${c}}`, r[c].toString()),
    e
  ) : e;
}
const i = Symbol("i18n");
export {
  i as k,
  t as r
};
//# sourceMappingURL=key.-LBAiGu1.js.map
